import { gql } from '@apollo/client/core';
import type { Ref } from 'vue';
import { computed } from 'vue';
import zvdzUseQuery from '@/common/composition/zvdzUseQuery';

export type ContactData = {
  dagenBereikbaar: string;
  email: string;
  reactieTijd: string;
  telefoonnummer: string;
  tijdenBereikbaar: string;
};

const GET_CONTACT_DATA = gql`
  query getContactData {
    contactData(input: {})
      @rest(method: "POST", path: "Home/GetContactGegevens") {
      factuurContactGegevens {
        dagenBereikbaar
        email
        reactieTijd
        telefoonnummer
        tijdenBereikbaar
      }
      klantteamContactGegevens {
        dagenBereikbaar
        email
        reactieTijd
        telefoonnummer
        tijdenBereikbaar
      }
    }
  }
`;

export default function useContactData(
  disableQuery?: Ref<boolean | undefined>,
): {
  customerTeamContactData: Ref<ContactData | undefined>;
  invoiceContactData: Ref<ContactData | undefined>;
  loading: Ref<boolean>;
} {
  const { result, loading } = zvdzUseQuery<{
    contactData: {
      klantteamContactGegevens: ContactData;
      factuurContactGegevens: ContactData;
    };
  }>(GET_CONTACT_DATA, undefined, () => ({
    enabled: !disableQuery?.value,
  }));
  const customerTeamContactData = computed(
    () => result.value?.contactData.klantteamContactGegevens,
  );
  const invoiceContactData = computed(
    () => result.value?.contactData.factuurContactGegevens,
  );

  return { customerTeamContactData, invoiceContactData, loading };
}
